/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Schedule_Kind_Date_OffsetInputs */

const cs_schedule_kind_date_offset = /** @type {(inputs: Schedule_Kind_Date_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posun od data`)
};

const en_schedule_kind_date_offset = /** @type {(inputs: Schedule_Kind_Date_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date offset`)
};

/**
* | output |
* | --- |
* | "Date offset" |
*
* @param {Schedule_Kind_Date_OffsetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const schedule_kind_date_offset = /** @type {((inputs?: Schedule_Kind_Date_OffsetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Schedule_Kind_Date_OffsetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_schedule_kind_date_offset(inputs)
	return cs_schedule_kind_date_offset(inputs)
});